<template>
  <div
    class="
      overflow-y-auto
      p-5
      ml-16
      mr-5
      mb-10
      rounded-lg
      border-2 border-blue-600
    "
  >
    <div id="title">
      <div class="btn btn-info w-full mb-5 bg-blue-600">Requirement Status</div>
    </div>
    <div v-if="tableData.length > 0">
      <pagination
        :currentState="currentState"
        :next="next"
        :pages="pages"
        :prev="prev"
        :state="state"
        class="flex items-end justify-end"
      />
      <table class="table w-full table-compact">
        <thead>
          <tr>
            <th>Id</th>
            <th>Job Title</th>
            <th>Post Date</th>
            <th>Package Fee</th>
            <th>Actions</th>
          </tr>
        </thead>
        <div v-if="loading" class="flex items-center justify-center">
          <img src="../../assets/830.svg" alt="loading" />
        </div>
        <tbody v-else>
          <tr v-for="(d, i) in tableData" :key="i">
            <th>{{ d.reqId }}</th>
            <th>{{ d.jobTitle }}</th>
            <th>{{ d.date.split(" ")[0] }}</th>
            <th>{{ d.fees }}</th>
            <td class="flex justify-evenly">
              <div
                class="tooltip tooltip-left"
                data-tip="View Data"
                @click="showMillView(i)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  />
                </svg>
              </div>
              <div
                class="tooltip tooltip-top cursor-pointer"
                data-tip="Proforma Data"
                @click="
                  showMillProfroma({
                    index: i,
                    status: d.proformaAccepted,
                    reqId: d.reqId,
                  })
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>
              <div v-if="d.paymentStatus === 'Success'">
                <span
                  class="tooltip tooltip-top cursor-pointer"
                  data-tip="PaymentSuccess"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    />
                  </svg>
                </span>
              </div>
              <div v-else-if="d.proformaAccepted === 'Y'">
                <span
                  @click="
                    showPayView({
                      amount: d.fees,
                      reqId: d.reqId,
                    })
                  "
                  class="tooltip tooltip-top cursor-pointer"
                  data-tip="Purchase Package"
                >
                  <svg
                    class="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                </span>
              </div>
              <div
                v-if="d.proformaAccepted === 'N'"
                class="tooltip tooltip-top cursor-pointer"
                data-tip="Delete Data"
                @click="deleteMillReq"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex items-center justify-center" v-else>
      <div class="text-2xl font-bold m-10">No New Notification 🤷‍♂️</div>
    </div>
    <div v-if="millView">
      <millview
        :data="tableData"
        :closeView="closeMillView"
        :i="millViewIndex"
      />
    </div>
    <div v-if="millProfroma">
      <millproforma
        :data="tableData"
        :i="millProformaIndex"
        :closeView="closeMillProforma"
        :statusUpdate="acceptOrCancle"
        :status="proformaAccepted"
        :close="closeProforma"
        :clicked="clicked"
      />
    </div>
    <div
      v-if="paymentView"
      class="
        p-6
        mx-auto
        fixed
        top-40
        left-72
        right-0
        z-50
        overflow-hidden
        card
        shadow-2xl
        bg-base-100
        modal-box
        mb-4
      "
    >
      <subscription-modal
        :orderId="orderId"
        :email="userData[0].Candidate_mailid"
        :amount="1"
        :mobileno="userData[0].Candidate_mobileno"
        :hide="hidePay"
        :name="userData[0].mill_name"
        :description="'Mill Service Transaction'"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import millview from "../Mill/forms-cards/millView.vue";
import millproforma from "../Mill/forms-cards/millProforma.vue";
import subscriptionModal from "../subscriptionModal.vue";
import Pagination from "./pagination.vue";

export default {
  name: "millTable",
  components: { millview, millproforma, subscriptionModal, Pagination },
  props: ["userData"],
  data() {
    return {
      tableData: [],
      millView: false,
      millViewIndex: Number(),
      millProfroma: false,
      millProformaIndex: Number(),
      loading: false,
      paymentStaus: false,
      paymentView: false,
      currentState: Number(1),
      pages: [],
      orderId: "",
      amount: Number(),
      proformaAccepted: "",
      reqId: Number(),
      clicked: false,
    };
  },
  created() {
    this.getMillRequirement(this.currentState);
    this.numbersForPage();
  },
  methods: {
    // Paginations Functions
    numbersForPage() {
      axios
        .post(
          `https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/GetDataCount`
        )
        .then((res) => {
          for (let i = 0; i < res.data.data; i++) {
            this.pages.push(i + 1);
          }
          this.loading = false;
        })
        .catch((err) => alert(err));
    },
    state(pageNumber) {
      this.currentState = pageNumber;
      this.getMillRequirement(this.currentState);
    },

    prev() {
      this.currentState--;
    },
    next() {
      this.currentState++;
    },
    showMillView(i) {
      this.millView = !this.millView;
      this.millViewIndex = i;
    },
    closeMillView() {
      this.millView = !this.millView;
    },
    showMillProfroma(i) {
      this.millProfroma = !this.millProfroma;
      this.millProformaIndex = i.index;
      this.proformaAccepted = i.status;
      this.reqId = i.reqId;
    },
    closeProforma() {
      this.millProfroma = !this.millProfroma;
    },
    closeMillProforma() {
      this.tableData = [];
      this.millProfroma = !this.millProfroma;
      this.getMillRequirement(this.currentState);
    },
    showPayView(i) {
      this.paymentView = !this.paymentView;
      this.amount = i.amount;
      sessionStorage.setItem("reqId", i.reqId);
      const defaults = {
        orderdetails: [{ receipt: this.userData[0].mill_name, amount: 1 }],
        customerid: this.userData[0].Reg_id,
        orderType: 6,
        ...this.userData[0],
      };

      axios
        .post(
          `https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/onlineserviceapi/index.php/api/insert_empservice_payment_transcations`,
          defaults
        )
        .then((res) => {
          this.orderId = res.data.payload.order_id;
        })
        .catch((err) => console.log(err));
    },
    hidePay() {
      this.paymentView = !this.paymentView;
      this.orderId = "";
    },
    getMillRequirement(i) {
      this.loading = true;
      let jdata = JSON.stringify({
        regId: sessionStorage.getItem("millId"),
        pageNo: i,
      });
      axios
        .post(
          `https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/GetMillRequirement`,
          jdata
        )
        .then((res) => {
          this.tableData.splice(0, 10);
          if (res.data.data) {
            res.data.data.forEach((e) => {
              this.tableData.push(e);
            });
            this.loading = false;
          } else {
            alert("Error Getting Data");
            this.loading = false;
          }
        })
        .catch((err) => {
          if (err) {
            alert("Error Getting Data");
            this.loading = false;
          }
        });
    },
    deleteMillReq() {
      this.loading = true;
      let jdata = JSON.stringify({
        regId: sessionStorage.getItem("millId"),
      });
      axios
        .put(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/DelMillRequirement`,
          jdata
        )
        .then((res) => {
          if (res.data.data) {
            this.tableData = [];
            this.getMillRequirement(this.currentState);
          } else {
            alert("Error Deleting Data");
          }
        })
        .catch((err) => {
          if (err) {
            alert("Error Sending Request");
          }
        });
      this.loading = false;
    },
    acceptOrCancle(d) {
      this.clicked = true;
      let jdata = JSON.stringify({
        reqId: this.reqId,
        status: d,
      });
      axios
        .put(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/AcceptMillProfroma`,
          jdata
        )
        .then((res) => {
          if (res.data.data) {
            this.paymentStaus = true;
            this.closeMillProforma();
            this.clicked = false;
          } else {
            alert("Error Sending Status");
            this.closeMillProforma();
            this.clicked = false;
          }
        })
        .catch((err) => {
          if (err) {
            alert("Error Sending Request");
            this.closeMillProforma();
            this.clicked = false;
          }
        });
    },
  },
};
</script>



<style>
.table {
  text-align: start;
}
</style>